import { RegexEnum } from '../../libs/enums';
import {
  mustBeFilled,
  mustBeLessThan,
  mustBeMoreThan,
  mustMatchFormat,
} from '../../libs/validators';

export const inputServiceProviderConfig = {
  description: 'Exemple : ANTS, Mon Compte Formation, ...',
  label: 'Site accédé',
  name: 'serviceProvider',
  validators: {
    format: [
      mustMatchFormat(
        RegexEnum.SERVICES,
        'Veuillez utiliser uniquement des caractères alpha-numériques ou de ponctuations',
      ),
      mustBeMoreThan(3),
      mustBeLessThan(256),
    ],
    submit: mustBeFilled('Veuillez renseigner le site accédé'),
  },
};
